import { OpenAccountModalContent } from '../ui';
import { useAccountOpeningTimer } from '@/features/account-open/model/useAccountOpeningTimer';
import type { OpenAccountResponseDto } from '@/features/account-open/api/types';
import type { OpenAccountType } from '@/features/account-open/model/types';
import { useCallback } from 'react';
import type { AccountType } from '@/entities/account';
import { useSessionStore } from '@/entities/session';
import { useVerificationInfoModal } from '@/entities/verification';
import { useModalStore } from '@/shared/lib';

const useAccountCreateModal = (type?: AccountType) => {
  const { showDialogComponent } = useModalStore();
  const { addPendingAccount } = useAccountOpeningTimer();
  const { session } = useSessionStore();
  const isVerified = session?.additional?.isVerified || false;
  const { openVerificationInfoModal } = useVerificationInfoModal();

  const onSuccess = useCallback(
    (
      data: OpenAccountResponseDto,
      accountType: OpenAccountType,
      assetCode?: string
    ) => {
      const tradingAccountKey = data.tradingAccountKey;
      if (tradingAccountKey && data?.openingTimeout && data?.accountNumber) {
        addPendingAccount(
          String(tradingAccountKey),
          accountType,
          data.openingTimeout,
          assetCode
        );
      }
    },
    [addPendingAccount]
  );

  const openCreateAccountModal = (overrideType?: AccountType) => {
    if (!isVerified) {
      openVerificationInfoModal();
      return;
    }

    const accountType = typeof overrideType === 'string' ? overrideType : type;

    showDialogComponent({
      component: (
        <OpenAccountModalContent onSuccess={onSuccess} type={accountType} />
      ),
      className: 'bg-secondary-bg',
    });
  };

  return {
    openCreateAccountModal,
  };
};

export { useAccountCreateModal };
